<div class="card mt-4">
  <h4 class="card-header card-title">{{ settings.title || 'Total Active Time' }}</h4>
  <div class="card-body">
    <div *ngIf="settings.subtitle">{{ settings.subtitle }}</div>
    <h2 *ngIf="error" class="text-danger">Error</h2>
    <h2 *ngIf="!error && value">{{ value }}</h2>
    <h2 *ngIf="!error && !value" class="spinner-border spinner-border-lg"></h2>
  </div>
</div>
